<template>
  <div class="addMenu">
    <div class="title">
      菜单管理 <span>修改菜单管理</span>
    </div>
    <div class="main">
      <div class="addEmailInfo">修改菜单管理</div>
      <div class="menuContent">
        <div class="menulist">
          <label for="menuname">
            <span>*</span>菜单名称
          </label>
          <el-input size="small"
                    placeholder="请输入菜单名称"
                    v-model="menuInfo.name"></el-input>
        </div>
        <div class="menulist">
          <label for="menunum">
            <span>*</span>排序
          </label>
          <el-input size="small"
                    v-model="menuInfo.sequence"></el-input>
        </div>
        <div class="menulist">
          <label for="remark">备注</label>
          <el-input type="textarea"
                    :autosize="{ minRows: 3, maxRows: 8}"
                    v-model="menuInfo.remark"></el-input>
        </div>
        <div class="menuBtn">
          <button class="save"
                  @click="handleAddEmailClick">
            保存
          </button>
          <button @click="handleCancelClick"
                  class="cancel">
            取消
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getMenuInfo, updateMenu } from 'apis/index'
export default {
  name: 'addMenu',
  data () {
    return {
      id: '',
      menuInfo: {
        name: '',
        sequence: '',
        remark: ''
      },
      pid: ''
    }
  },
  methods: {
    getData (id) { // 修改初始化
      getMenuInfo({ id: id }).then(res => {
        if (res.data.code === 200) {
          // console.log(res)
          this.menuInfo.name = res.data.data.name
          this.menuInfo.sequence = res.data.data.sort
          this.menuInfo.remark = res.data.data.remark
          this.pid = res.data.data.pid
        }
      })
    },
    handleAddEmailClick () { // 修改
      updateMenu({
        id: this.id,
        name: this.menuInfo.name,
        sort: this.menuInfo.sequence,
        pid: this.pid
      }).then(res => {
        if (res.data.code === 200) {
          this.$router.push({ path: '/system/menu' })
        }
      })
    },
    handleCancelClick () { // 取消添加/修改
      this.$router.push({ path: '/system/menu' })
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.getData(this.id)
    // console.log(this.id)
  }
}
</script>
<style lang="stylus">
.addMenu
  position absolute
  top 0px
  bottom 20px
  left 20px
  right 20px
  z-index 1
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 57px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #fff
    height calc(100% - 50px)
    .addEmailInfo
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../assets/images/03/add_icon.png') no-repeat center left 15px
    .menuContent
      width 100%
      height calc(100% - 62px)
      padding-top 14px
      border-top 1px solid #CFD5DC
      border-bottom 1px solid #CFD5DC
      .menulist
        margin-top 26px
        label
          width 154px
          float left
          line-height 32px
          text-align right
          font-size 12px
          color #5E656F
          span
            color #FF344A
        .el-input
          width 220px
          margin-left 12px
        .el-textarea
          width 475px
          margin-left 12px
      .menuBtn
        margin-left 153px
        margin-top 94px
        button
          padding 4px 26px
          cursor pointer
          margin 0 20px
          background #FFFFFF
          border-radius 3px
          border 1px solid #CFD5DC
          &:hover
            background #1B88EE
            color #fff
            border 1px solid #1B88EE
</style>
